import http from '@/api/common'

export default {
  getStates () {
    return http.get(`location/getstates`)
  },
  getLocation (locationID) {
    return http.get(`location/get?id=${locationID}`)
  },
  getLocationsByUser (params) {
    return http.get('location/getbyuser', { params })
  },
  createLocation (location) {
    return http.post('location/create', location)
  },
  updateLocation (location) {
    return http.post('location/update', location)
  },
  deleteLocation (location) {
    return http.post('location/delete', location)
  },
  getReportKPI (locationID) {
    let params = typeof locationID !== 'undefined' ? `?locationID=${locationID}` : ''
    return http.post(`location/getreportkpi${params}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/locations.js